var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpenseOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#03B09B",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7734_23220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3787 36.9943L25.332 27.333H42.1667C43.0347 27.333 43.6707 28.1477 43.46 28.9903L41.6627 36.1797C41.3894 37.2717 40.4614 38.0743 39.3414 38.1863L30.2534 39.0957C28.8987 39.2303 27.66 38.325 27.3787 36.9943V36.9943Z",
    stroke: "#03B09B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 27.333L24.4666 23.333H22.168",
    stroke: "#03B09B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3096 43.6904C40.0402 43.6904 39.8216 43.9091 39.8242 44.1784C39.8242 44.4478 40.0429 44.6664 40.3122 44.6664C40.5816 44.6664 40.8002 44.4478 40.8002 44.1784C40.7989 43.9091 40.5802 43.6904 40.3096 43.6904Z",
    fill: "#03B09B",
    stroke: "#03B09B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0947 43.6904C28.8254 43.6904 28.6067 43.9091 28.6094 44.1784C28.6067 44.4491 28.8267 44.6678 29.0961 44.6678C29.3654 44.6678 29.5841 44.4491 29.5841 44.1798C29.5841 43.9091 29.3654 43.6904 29.0947 43.6904Z",
    fill: "#03B09B",
    stroke: "#03B09B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7734_23220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(17.5 18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseOff);
export default __webpack_public_path__ + "static/media/expenseOff.1bda2c55dd7d429a3aad50a42540eb84.svg";
export { ForwardRef as ReactComponent };